import { AxiosResponse } from 'axios';
import { CatalogCountryDto } from '../../../types/dto/CatalogCountryDto';
import { CatalogCountry } from '../../../types/CatalogCountry';

const mapCatalogCountryDtoToCatalogCountry = ({ data }: AxiosResponse<CatalogCountryDto[]>): CatalogCountry[] =>
  data.map(({ id, name }) => ({ id, name }));

export default mapCatalogCountryDtoToCatalogCountry;
